import { WorkingCopyKey } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import InfoLink from '../common/InfoLink';
import { validateContent } from '../../api/ValidationUtil';
import EditContentData from '../workflow-viewer/content/EditContentData';
import { ContentSchemaSection } from '../../model/ContentSchemaSection';
import { filterInlineCommentsToUpdate } from '../utils/InlineCommentUtils';
import { Box, SpaceBetween } from '@amzn/awsui-components-core';

class PublicationEditContentData extends EditContentData {
  protected workingCopyKey = WorkingCopyKey.finalizingworkingcopy;
  protected autoEnableEditingWithWorkingCopy = true;

  // @ts-expect-error TS2416 - strict migration
  protected saveChanges = async (preview: boolean) => {
    const { contentId, workflowId, onDisableEditMode } = this.props;
    const { updatedContent } = this.state;
    await this.mplService.updateFinalizingContent(contentId, workflowId, updatedContent);
    const { inlineComments: allInlineComments } = await this.mplService.listInlineComments(
      contentId,
      workflowId,
    );

    const mostRecentWorkingCopy = await this.workingCopyMngr.getMostRecentWorkingCopy(
      this.props.contentId,
      this.workingCopyKey,
    );
    const updatedInlineComments = filterInlineCommentsToUpdate(
      // @ts-expect-error TS2345 - strict migration
      mostRecentWorkingCopy?.workingCopy?.updatedInlineComments,
      allInlineComments,
    );
    if (updatedInlineComments?.length) {
      const updateCommentAttributes = updatedInlineComments.map((comment) => ({
        commentId: comment.commentId,
        finalizingStartOffset: comment.startOffset,
        finalizingEndOffset: comment.endOffset,
        finalizingTextData: comment.textData,
      }));
      await this.mplService.updateInlineComments(contentId, workflowId, updateCommentAttributes);
    }
    await this.workingCopyMngr.deleteWorkingCopies(contentId, this.workingCopyKey);

    this.setState({
      formError: null,
      isContentUnchanged: true,
    });

    if (preview) {
      if (onDisableEditMode) {
        await onDisableEditMode();
      }
    }
  };

  // @ts-expect-error TS2416 - strict migration
  protected discardChanges = async () => {
    const { contentId, onDisableEditMode } = this.props;
    if (onDisableEditMode) {
      await onDisableEditMode();
    }

    await this.workingCopyMngr.deleteWorkingCopies(contentId, this.workingCopyKey);

    this.setState({
      isContentUnchanged: true,
    });
  };

  protected beforeSaving = async () => {
    const entities = this.props.appContext?.entities || {};
    const {
      contentMetadataError,
      templateValidationError,
      contentDataValidationError,
      contentDataLinkValidationError,
      isValid,
    } = validateContent(
      this.state.updatedContent,
      new Set([
        ContentSchemaSection.ContentMetadata,
        ContentSchemaSection.TemplateMetadata,
        ContentSchemaSection.ContentSections,
      ]),
      entities,
    );
    if (isValid) {
      return true;
    } else {
      const errors = Array.from(
        new Map([
          ...contentMetadataError,
          ...templateValidationError,
          ...contentDataValidationError,
        ]),
      ).map((e) => ({ key: e[0], value: e[1] }));
      errors.push(...contentDataLinkValidationError);
      this.setState({
        formError: (
          <div>
            <SpaceBetween size="xxs">
              {errors.map((e) => (
                <Box key={e.key}>
                  <Box variant="strong" display="inline">
                    {e.key}:
                  </Box>{' '}
                  {e.value}
                </Box>
              ))}
            </SpaceBetween>
            {this.showPathSlug()}
          </div>
        ),
      });
      return false;
    }
  };

  // @ts-expect-error TS2416 - strict migration
  protected showPathSlug = () => {
    return (
      <i>
        For Pathslug, Page ID and Section ID rules. Please review <InfoLink topic="content-href" />{' '}
        here
      </i>
    );
  };
}

export default PublicationEditContentData;
